import React from 'react'
import ContentLoader from 'react-content-loader'
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'store/hook';

const TableLoader = (props: any) => {
  const { isDarkMode } = useAppSelector((state) => state.windowState);

  const numberOfRows = 40;
  const numberOfColumns = 20;
  let arrayOfCols = Array(numberOfColumns).fill(0);
  let arrayOfRows = Array(numberOfRows).fill(0);  
    
  const { t } = useTranslation();
  const marginTop = props.margintop || 20;
  return (
  <div style={{
    padding: props.padding || 15,
    margin: props.margin || 0,
    overflow: 'hidden',
    backgroundColor: isDarkMode ? '#141414' : 'white',
    display: 'flex',
    height: props.height,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: props.borderradius || 0,
  }}>
    <ContentLoader 
      speed={2}
      width={'100%'}
      height={props.height || 600}
      title={t('Documents.table.loader')}
      backgroundColor={isDarkMode ? '#303030ff' : '#f5f6f7'}
      foregroundColor={isDarkMode ? '#101010ff' : '#eee'}
      {...props}
    > 
      {arrayOfRows.map((col, i) => arrayOfCols.map((row, j) => (
        <rect key={`${i}_${j}`} x={col + (180 * j)} y={(40 * i) + marginTop} rx='0' ry='0' width='170' height='20' />
      )))}
    </ContentLoader>
  </div>
)
}
export default TableLoader
